import { createRoute } from '@tanstack/react-router';
import type { Zone } from '@hana/shell';
import { meeApiRoutes, registerMeeFixtures } from './data';
import { ApproveScreen } from './approve/Approve';
import { DocsScreen } from './docs/Docs';
import { GrowScreen } from './grow/Grow';
import { LeaveScreen } from './home/Leave';
import { OverviewScreen } from './home/Overview';
import { PayScreen } from './pay/Pay';
import { PayrollScreen } from './payroll/Payroll';
import { TimeScreen } from './time/Time';
import { CheckinScreen } from './checkin/Checkin';
import { hrRoutes } from './hr/module';
import { registerHrFixtures } from './hr';
import { currentSearch, meeNav } from './nav';

// Vùng HANA Mee (/mee): phép, chấm công, đơn từ (luồng B, docs/streams/B.md). Board Mint-Mee.

export const zone: Zone = {
  key: 'mee',
  fixtures: (register) => {
    registerMeeFixtures(register);
    registerHrFixtures(register);
  },
  name: 'HANA Mee',
  // Tìm nhanh chỉ ở lớp NHÂN SỰ (board Mint-HR có nút, Mint-Mee không)
  get findButton() {
    return typeof location !== 'undefined' && location.pathname.startsWith('/mee/hr');
  },
  // Menu chung của Hub (sidebar 248 / rail 64), theo người xem — xem nav.ts
  get top() {
    return meeNav(currentSearch()).top;
  },
  get nav() {
    return meeNav(currentSearch()).nav;
  },
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/', component: OverviewScreen }),
    createRoute({ getParentRoute: () => parent, path: 'time', component: TimeScreen }),
    createRoute({ getParentRoute: () => parent, path: 'checkin', component: CheckinScreen }),
    createRoute({ getParentRoute: () => parent, path: 'pay', component: PayScreen }),
    createRoute({ getParentRoute: () => parent, path: 'payroll', component: PayrollScreen }),
    createRoute({ getParentRoute: () => parent, path: 'docs', component: DocsScreen }),
    createRoute({ getParentRoute: () => parent, path: 'grow', component: GrowScreen }),
    createRoute({ getParentRoute: () => parent, path: 'approve', component: ApproveScreen }),
    createRoute({ getParentRoute: () => parent, path: 'leave', component: LeaveScreen }),
    ...hrRoutes(parent),
  ],
};

/** route `api` của Mee (Hub gom vào `API_ROUTES`) */
export const apiRoutes = meeApiRoutes;
